import { createContext, useContext, useState } from 'react';
import PopupForm from '@/components/shared/PopupForm';

const PopupContext = createContext();

export function PopupProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [packageInfo, setPackageInfo] = useState({ title: '', amount: 0 });

  const openPopup = (title = '', amount = 0) => {
    setPackageInfo({ title, amount });
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
  };

  return (
    <PopupContext.Provider value={{ openPopup, closePopup }}>
      {children}
      <PopupForm isOpen={isOpen} onClose={closePopup} packageInfo={packageInfo} />
    </PopupContext.Provider>
  );
}

export const usePopup = () => useContext(PopupContext);
